<ng-container [ngSwitch]="htmlElement">
  <ng-container *ngSwitchCase="'TR'">
    <td colspan="100">
      <div class="d-flex align-items-center" style="height: 170px;">
        <div class="card uploadWrapper h-100 m-0 w-100">
          <sb-comp-file-upload [uploadType]="'medium'"></sb-comp-file-upload>
        </div>
      </div>
    </td>
  </ng-container>
  <ng-container *ngSwitchDefault>
    <div [ngClass]="{'box-dragover': isDragOver}" class="card height-fluid uploadWrapper">
      <sb-comp-file-upload (isDragOverEmitter)="isDragOver = $event" [uploadType]="'medium'"></sb-comp-file-upload>
    </div>
  </ng-container>
</ng-container>
